import { Section } from '../../models/menu.interfaces';

export const TripsSectionMocks: Section = {
  id: 'trips',
  title: 'My Trips',
  items: [],
  url: '/mytrips/',
  opened: false
};
